import { HStack, List, ListItem, Text } from "@chakra-ui/react";

import { FragmentType, getFragmentData, graphql } from "@/__generated__";
import Section from "@/components/shared/Section";
import WorkspaceIcon from "@/components/shared/WorkspaceIcon";

const UserProfileWorkspaces_User = graphql(`
  fragment UserProfileWorkspaces_User on User {
    id
    roles {
      nodes {
        id
        name
        workspace {
          id
          name
          ...WorkspaceIcon_Workspace
        }
      }
    }
  }
`);

interface Props {
  user: FragmentType<typeof UserProfileWorkspaces_User>;
}

export default function Workspaces(props: Props) {
  const user = getFragmentData(UserProfileWorkspaces_User, props.user);
  return (
    <Section heading="Workspaces">
      <List variant="spaced">
        {user.roles.nodes.map(role => (
          <ListItem key={role.workspace.id}>
            <HStack>
              <WorkspaceIcon height="60px" width="60px" workspace={role.workspace} />
              <div>
                <Text color="text.darkest" fontSize="lg" fontWeight="bold" ml={2}>
                  {role.workspace.name}
                </Text>
                <Text ml={2}>{role.name}</Text>
              </div>
            </HStack>
          </ListItem>
        ))}
      </List>
    </Section>
  );
}
